export const hongbao = {
    hb: "Envelope vermelho",
    dps: "Grande distribuição",
    xdhb: "Envelopes vermelhos limitados, milhões de recompensas esperando por você",
    fxhb: "Compartilhe envelopes vermelhos para ganhar ainda mais recompensas",
    khb: "Abrir envelope vermelho",
    kqz: "Abrindo...",
    ylq: "Resgatado",
    hdwks: "Evento não iniciado",
    hdjxz: "Evento em andamento",
    hdyjs: "Evento encerrado",
    hddjs: "Contagem regressiva do evento",
    hdsj: "Período do evento",
    zwhd: "Nenhum evento no momento",
    hblsjlxq: "Meu histórico de recompensas",
    jxz: "Em andamento",
    ygq: "Expirado",
    dks: "Em breve",
    zwjl: "Nenhuma recompensa ainda",
    wnmztj: "Você não atende aos requisitos do evento",
    wxts: "Aviso",
    yhwcrz: "O usuário completou a verificação KYC e o vínculo do número de celular",
    yhwcjy: "O usuário completou um dos seguintes: negociação à vista ≥100 USDT OU negociação de contratos (sem alavancagem) ≥100 USDT OU negociação de opções ≥100 USDT OU negociação GameFi ≥100 USDT",
    djzh: "Contas sob controle de risco ou com saque restrito não podem participar do evento.",
    hdhbjl: "Recompensa Recebida",
    sqbj: "Sem sorte desta vez",
    dkapp: "Abra o aplicativo",
    smewm: "Escaneie o código QR",
    wchdtj: "Cumpra os requisitos do evento para resgatar o envelope vermelho",
    fxhd: "Compartilhe o evento para ganhar mais envelopes vermelhos",
    jdcz: "Passos simples para gerar renda",
    hdhb: "Envelopes Vermelhos do Evento",
    zdqj: "Período Específico",
    wcjye: "Complete o volume de transações {type} {text} ≥ {amount} USDT",
    yhwfhtj: "Dentro de {time} antes do lançamento do envelope vermelho, o usuário não tinha transações elegíveis",
    hbsxq: "Dentro de {time}{day} antes do lançamento do envelope vermelho, o usuário {text}",
    bhgg: "Excluindo alavancagem",
    h: " ou ",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/pt_BR.js